import { SdohSingleAnswerAdvanced } from './SdohSingleAnswerAdvanced.model';

export default interface ISocialAndEmotionalHealth {
    HowOftenDoYouSeeOrTalkToPeople: SdohSingleAnswerAdvanced | null;
    HowStressedAreYou: SdohSingleAnswerAdvanced | null;
    IsAIHowOftenDoYouSeeOrTalkToPeople?: boolean;
    IsAIHowStressedAreYou?: boolean;
}

export class SocialAndEmotionalHealth implements ISocialAndEmotionalHealth {
    HowOftenDoYouSeeOrTalkToPeople: SdohSingleAnswerAdvanced | null;
    HowStressedAreYou: SdohSingleAnswerAdvanced | null;
    IsAIHowOftenDoYouSeeOrTalkToPeople?: boolean;
    IsAIHowStressedAreYou?: boolean;

    constructor() {
        this.HowOftenDoYouSeeOrTalkToPeople = new SdohSingleAnswerAdvanced();
        this.HowStressedAreYou = new SdohSingleAnswerAdvanced();
    }
}
